/* @flow */
import cx from 'classnames';
import React from 'react';

import ClickEventTrigger from 'components/ClickEventTrigger.jsx';
import getPropClasses from 'lib/getPropClasses';
import LinkBase from 'components/LinkBase.jsx';
import LoadingIndicator from 'components/LoadingIndicator.jsx';
import tooltipable from 'lib/tooltipable';

import './styles/Button.scss';

const propsToClasses = {
  level: {
    primary: 'Button--primary',
    secondary: 'Button--secondary',
    text: 'Button--text',
    icon: 'Button--icon',
  },
  color: {
    lava: 'Button--lava',
    sunrise: 'Button--sunrise',
    shamrock: 'Button--shamrock',
    jungle: 'Button--jungle',
    brand: 'Button--brand',
    violet: 'Button--violet',
    pitch: 'Button--pitch',
    thunder: 'Button--thunder',
    eclipse: 'Button--eclipse',
    koala: 'Button--koala',
    white: 'Button--white',
  },
  shape: {
    circle: 'Button--circle',
  },
  size: {
    small: 'Button--small',
    xsmall: 'Button--xsmall',
    xxsmall: 'Button--xxsmall',
  },
  weight: {
    normal: 'Button--normal',
    semibold: 'Button--semibold',
  },
  full: 'Button--full',
};

/*
 * Basic Button components - used everywhere in our product.
 */
const Button = React.createClass({
  propTypes: {
    level: React.PropTypes.oneOf([
      'primary', 'secondary', 'text', 'icon',
    ]),
    color: React.PropTypes.oneOf([
      'lava', 'sunrise', 'shamrock', 'jungle', 'brand', 'violet', 'pitch', 'thunder', 'eclipse', 'koala', 'white',
    ]),
    size: React.PropTypes.oneOf(['small', 'xsmall', 'xxsmall']),
    shape: React.PropTypes.oneOf(['circle']),
    weight: React.PropTypes.oneOf(['normal', 'semibold']),
    full: React.PropTypes.bool,
    inline: React.PropTypes.bool,
    disabled: React.PropTypes.bool,
    loading: React.PropTypes.bool,
    to: LinkBase.propTypes.to,
    href: LinkBase.propTypes.href,
    onClick: React.PropTypes.func,
    'data-test-selector': React.PropTypes.string,
    'data-test': React.PropTypes.string,
    download: React.PropTypes.bool,
    target: React.PropTypes.string,
    type: React.PropTypes.string,
    id: React.PropTypes.string,
    eventElementName: React.PropTypes.string,
  },

  getDefaultProps() {
    return {
      disabled: false,
      inline: false,
      level: 'primary',
      loading: false,
      size: 'small',
    };
  },

  isDisabled() {
    return (
      this.props.disabled ||
      this.props.loading
    );
  },

  renderChildren() {
    const lightBackground = (
      this.props.color === 'white' ||
      this.props.level === 'secondary'
    );

    if (this.props.loading) {
      const color = lightBackground ? 'eclipse' : 'white';
      return <LoadingIndicator size={this.props.size} color={color} />;
    } else {
      return this.props.children;
    }
  },

  render() {
    const hasTarget = (this.props.to || this.props.href);
    const Component = hasTarget ? LinkBase : 'button';
    return (
      <ClickEventTrigger eventElementName={this.props.eventElementName}>
        <Component
          id={this.props.id}
          type={this.props.type}
          target={this.props.target}
          href={this.props.href}
          to={this.props.to}
          download={this.props.download}
          onMouseEnter={this.props.onMouseEnter}
          onMouseLeave={this.props.onMouseLeave}
          onMouseMove={this.props.onMouseMove}
          data-test-selector={this.props['data-test-selector']}
          data-test={this.props['data-test']}
          onClick={this.props.onClick}
          disabled={this.isDisabled()}
          className={cx('Button', this.props.className, {
            'Button--inline': this.props.inline,
            'Button--disabled': this.isDisabled(),
          }, getPropClasses(this.props, propsToClasses))}>
          {this.renderChildren()}
        </Component>
      </ClickEventTrigger>
    );
  },
});

export default tooltipable(Button);



// WEBPACK FOOTER //
// ./src/components/Button.jsx